
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.906 9.344L5.75 10.5a.628.628 0 01-.881.006c-.069-.069-.138-.131-.207-.2A17.754 17.754 0 012.92 8.263 11.142 11.142 0 011.694 6.13C1.4 5.42 1.25 4.737 1.25 4.088c0-.425.075-.832.225-1.207.15-.381.387-.731.719-1.043.4-.394.837-.588 1.3-.588.175 0 .35.038.506.113.162.075.306.187.419.35l1.45 2.043c.112.157.194.3.25.438a.988.988 0 01.087.381c0 .15-.044.3-.131.444-.081.143-.2.293-.35.444l-.475.493a.334.334 0 00-.1.25c0 .05.006.094.019.144.019.05.037.088.05.125.112.206.306.475.581.8.281.325.581.656.906.987.063.063.131.125.194.188.25.244.256.644.006.894zM13.731 11.457a1.588 1.588 0 01-.156.68 2.576 2.576 0 01-.425.638 2.817 2.817 0 01-1.025.738c-.006 0-.012.006-.019.006-.368.15-.768.231-1.2.231-.637 0-1.319-.15-2.037-.456a10.973 10.973 0 01-2.15-1.237A15.704 15.704 0 016 11.5l2.044-2.043c.175.13.331.23.462.3.031.012.069.03.113.05.05.018.1.025.156.025a.344.344 0 00.256-.107l.475-.468c.156-.157.306-.275.45-.35a.832.832 0 01.444-.132c.119 0 .244.025.381.082.138.056.281.137.438.243l2.069 1.47a.949.949 0 01.343.4c.063.155.1.312.1.487z","fill":"#838883"}})])
          )
        }
      }
    